<div class="wrapper">
  <button nz-button nzType="primary"
    [disabled]="
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-initialized' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-pending-fee' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signing-in-process' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signed-pending-approval' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signed'
    "
    (click)="getAccessFn()">{{ segment.name }}</button>
  <nz-alert
    *ngIf="
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-initialized' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-pending-fee' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signing-in-process' ||
      segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signed-pending-approval'
    "
    nzType="info"
    [nzMessage]="infoTemplate"></nz-alert>
  <ng-template #infoTemplate>
      <span *ngIf="segmentsMapper?.get(segment.code)?.status.configKey === 'contract-initialized'">This contract was initiated, but not completed. <a (click)="goToContract(segmentsMapper.get(segment.code).id)">See contract</a></span>
      <span *ngIf="segmentsMapper?.get(segment.code)?.status.configKey === 'contract-pending-fee'">This contract was initiated, but its fees were not paid. <a (click)="goToOrder(segmentsMapper.get(segment.code))">See pending order</a></span>
      <span *ngIf="segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signing-in-process'">This contract is waiting for signatures. <a (click)="goToContract(segmentsMapper.get(segment.code).id)">See contract</a></span>
      <span *ngIf="segmentsMapper?.get(segment.code)?.status.configKey === 'contract-signed-pending-approval'">This contract is waiting for the seller's approval and/or signature.</span>
  </ng-template>
</div>
